"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/default`;
    }
    /**
     * Returns a default bridge (PMI) for the user specified by **accountId**
   * and **extensionId** identifiers.
   *
     * HTTP Method: get
     * Endpoint: /rcvideo/v2/account/{accountId}/extension/{extensionId}/bridges/default
     * Rate Limit Group: Medium
     * App Permission: Video
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map